export const secretAchievements = [
  {
    id: 11,
    name: "Первое всегда бесплатное",
    description: "Нажмите на это Достижение."
  },
  {
    id: 12,
    name: "На всякий случай",
    get description() { return `Сохранитесь ${formatInt(100)} раз без обновления страницы.`; }
  },
  {
    id: 13,
    name: "Это выгодно - иметь уважение",
    description: "Почтите память."
  },
  {
    id: 14,
    name: "Я тоже",
    description: "Скажите что-то неприличное."
  },
  {
    id: 15,
    name: "Сделайте бочку!",
    description: "Следайте бочку.",
  },
  {
    id: 16,
    name: "Тебе нравится боль?",
    get description() {
      return `Используйте "болезненную" форму записи на протяжении ${formatInt(10)} минут реального времени
      после Вечности.`;
    },
    checkRequirement: () => AchievementTimers.pain
      .check(PlayerProgress.eternityUnlocked() && Notations.current.isPainful, 600),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER
  },
  {
    id: 17,
    name: "30 Жизней",
    description: "Введите код Konami."
  },
  {
    id: 18,
    name: "Чувствуешь себя счастливым? А? Панк.",
    get description() {
      return `Шанс ${formatInt(1)}/${formatInt(1e5)} получить это достижение каждую секунду.`;
    }
  },
  {
    id: 21,
    name: "Иди лучше исследуй в реальной жизни",
    description: "Купите секретное Временное Исследование."
  },
  {
    id: 22,
    name: "Сильно прожаренный",
    get description() { return `Купите ${formatInt(1e5)} Галактик Антиматерии всего, используя форму записи эмодзи.`; },
    checkRequirement: () => player.requirementChecks.permanent.emojiGalaxies >= 1e5,
    checkEvent: GAME_EVENT.GALAXY_RESET_AFTER
  },
  {
    id: 23,
    name: "Стой где стоишь, криминальный негодяй!",
    description: "Откройте консоль."
  },
  {
    id: 24,
    name: "Реальные новости",
    description: "Нажмите на новостное сообщение, которое делает что-либо, когда вы на него нажимаете."
  },
  {
    id: 25,
    name: "Шшшш... Это секрет",
    description: "Обнаружьте секретную тему."
  },
  {
    id: 26,
    name: "Ты неудачник",
    get description() {
      return `Провалите Вечный Челлендж ${formatInt(10)} раз без перезагрузки.
      Что ты делаешь со своей жизнью...`;
    },
    checkRequirement: (function() {
      let count = 0;
      return () => ++count >= 10;
    }()),
    checkEvent: GAME_EVENT.CHALLENGE_FAILED
  },
  {
    id: 27,
    name: "Она не называется измерения материи, так ведь?",
    description: "Заработайте Бесконечную матрию.",
    checkRequirement: () => Currency.matter.gte(Decimal.NUMBER_MAX_VALUE),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER
  },
  {
    id: 28,
    name: "Найс.",
    description: "Не веди себя так, как будто не знаешь что натворил."
  },
  {
    id: 31,
    name: "Тебе нужно загрузить немного больше оперативки",
    get description() { return `Установите частоту обновления на ${formatInt(200)}мс.`; }
  },
  {
    id: 32,
    name: "Меньше или равно 0.001",
    get description() {
      return `Получите самую быструю Бесконечность или Вечность за ${format(0.001, 3, 3)} секунд или меньше.`;
    },
    checkRequirement: () =>
      Time.bestInfinity.totalMilliseconds <= 1 ||
      Time.bestEternity.totalMilliseconds <= 1,
    checkEvent: [GAME_EVENT.BIG_CRUNCH_AFTER, GAME_EVENT.ETERNITY_RESET_AFTER]
  },
  {
    id: 33,
    name: "Разумное финансовое решение",
    description: "Нажмите на кнопку покупки ЗППП-коинов."
  },
  {
    id: 34,
    name: "Ты знаешь как они работают, правильно?",
    description: "Используйте Сброс Исследований с пустым Древом."
  },
  {
    id: 35,
    name: "Может быть стоит рассказать ему про покупку максимума...",
    get description() { return `Купите одиночное улучшение Скорости Тика  ${formatInt(1e5)} раз.`; },
    checkRequirement: () => player.requirementChecks.permanent.singleTickspeed >= 1e5,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER
  },
  {
    id: 36,
    name: "Пока вас не было... Ничего не прошло.",
    description: "Увидьте уведомление о том, что ничего не произошло, пока вас не было."
  },
  {
    id: 37,
    name: "Вы последовали инструкции",
    description: "Последуйте инструкции."
  },
  {
    id: 38,
    name: "Острие ножа",
    description: "Закройте уведомление Жёсткого Сброса после того, как напечатали подтверждение."
  },
  {
    id: 41,
    name: "Этого измерения не существует",
    description: "Попытайтесь купить 9ое Измерение."
  },
  {
    id: 42,
    name: "ПОЗОР МНЕ",
    description: "Попробуйте использовать ВЧ12 чтобы ускорить время."
  },
  {
    id: 43,
    name: "Какофонический хор",
    description: "Экипируйте Музыкальные Глифы во все доступные слоты для Глифов.",
    checkRequirement: () => Glyphs.active.length && Glyphs.active.every(x => Glyphs.isMusicGlyph(x)),
    checkEvent: GAME_EVENT.GLYPHS_EQUIPPED_CHANGED
  },
  {
    id: 44,
    name: "Теперь ты доволен? Ты сам хотел скорее вырасти.",
    get description() {
      return `Сосредоточенно смотрите на вкладку статистики на протяжении ${formatInt(15)} реальных минут.`;
    },
    checkRequirement: () => AchievementTimers.stats.check(Tab.statistics.isOpen, 900),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER
  },
  {
    id: 45,
    name: "Это перетаскивание затягивается",
    description: "Перетаскивайте Перки на протяжении минуты.",
    checkRequirement: () => player.requirementChecks.permanent.perkTreeDragging++ / 100 >= 60
  },
  {
    id: 46,
    name: "На чёрный день",
    description: "Накопите день реального времени."
  },
  {
    id: 47,
    name: "АЛЬТ+",
    description: "Скройте все вкладки, которые можно скрыть."
  },
  {
    id: 48,
    name: "Переполнение стэка",
    description: "Имейте больше ошибок, чем строк кода в Автоматизаторе."
  },
];
